module.exports = __webpack_public_path__ + "5e63698604c1fad59cd9318b17716c8c.png";